import { gateVisible, type GateContext } from "./gating";
import type { NavItem } from "./navConfig";

/** The nav's view of the shared gate (ADR 274). The rules — and the reason the
 *  provisioning check runs before the global-admin bypass — live in `gating.ts`,
 *  which the home widgets read from too. */
export type NavGateContext = GateContext;

export function navItemVisible(item: NavItem, ctx: NavGateContext): boolean {
  return gateVisible(item, ctx);
}
